/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rowrequestemailshint3Inputs */

const en_rowrequestemailshint3 = /** @type {(inputs: Rowrequestemailshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`At most one email with new requests every 15 minutes.`)
};

const de_rowrequestemailshint3 = /** @type {(inputs: Rowrequestemailshint3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Höchstens alle 15 Minuten eine E-Mail mit neuen Anfragen.`)
};

/**
* | output |
* | --- |
* | "At most one email with new requests every 15 minutes." |
*
* @param {Rowrequestemailshint3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const rowrequestemailshint3 = /** @type {((inputs?: Rowrequestemailshint3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rowrequestemailshint3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rowrequestemailshint3(inputs)
	return de_rowrequestemailshint3(inputs)
});
export { rowrequestemailshint3 as "rowRequestEmailsHint" }